var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled, { css } from "styled-components";
// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";
// data
import { primaryMenu } from "data/links";
// components
import Link, { AnchorStyled } from "./Link.js";
// styles
import colors from "core/colors";
import { bold as boldFontWeight } from "core/fontStyles";
import { convertPxToRem } from "frontend/components/helpers";
var PricingLinkStyled = styled(Link)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border: none;\n    margin: 0rem ", " 0rem 0rem;\n\n    ", " {\n        ", "\n        color: ", ";\n        &:hover {\n            color: ", ";\n            text-decoration: none;\n            border-bottom-color: transparent;\n        }\n\n        ", "\n    }\n"], ["\n    border: none;\n    margin: 0rem ", " 0rem 0rem;\n\n    ", " {\n        ", "\n        color: ", ";\n        &:hover {\n            color: ", ";\n            text-decoration: none;\n            border-bottom-color: transparent;\n        }\n\n        ", "\n    }\n"])), convertPxToRem(16), AnchorStyled, boldFontWeight, colors.accent.lightMode.persian, colors.accent.lightMode.pansy, function (_a) {
    var $isDarkMode = _a.$isDarkMode;
    return $isDarkMode && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                color: ", ";\n                &:hover {\n                    color: ", ";\n                    border-bottom-color: transparent;\n                }\n            "], ["\n                color: ", ";\n                &:hover {\n                    color: ", ";\n                    border-bottom-color: transparent;\n                }\n            "])), colors.accent.darkMode.suenosBuenos, colors.accent.darkMode.surf);
});
// component
export var PricingLink = function (_a) {
    var onFocus = _a.onFocus, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b;
    var isDarkMode = useSiteHeader().isDarkMode;
    var pricing = primaryMenu.products.links.pricing;
    return (_jsx(PricingLinkStyled, { link: pricing, "$isDarkMode": isDarkMode, onFocus: onFocus, isDisabled: isDisabled, onMouseDown: pricing.track }));
};
export default PricingLink;
var templateObject_1, templateObject_2;
